import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../translations/i18n';
import {useAuth} from '../hooks/auth';
import {useConfig} from '../hooks/config';
import {useLayout} from '../hooks/layout';
import Img from './Img';
import { Helmet } from 'react-helmet-async';
import { Grid, Typography, Box, Link, List, ListItem, ListItemButton, ListItemText, Stack, Container } from '@mui/material';
import { SocialIcon } from 'react-social-icons';
import cicLogo from '../assets/icons/cic.svg';

const Footer = () => {

	const {user} = useAuth();
	const {config} = useConfig();
	const {isMobile} = useLayout();

	const initializeFacebook = () => {
	    if (!window.FB) return;
	    window.fbAsyncInit = () => {
	      window.FB.init({
	        appId            : process.env.REACT_APP_FACEBOOK_APP_ID,
	        autoLogAppEvents : true,
	        xfbml            : true,
	        version          : 'v15.0'
	      });
	    };
	}

	return(
		<Box
			sx={{
				backgroundColor: '#F5F1EA'
			}}
		>
			<Helmet
			    script={[
			        {
			        	src: '//cdn.iubenda.com/cs/iubenda_cs.js', 
			        	type: 'text/javascript', 
			        	async: true,
			        	charset: 'UTF-8' 
			        },{
			        	id: 'facebook-jssdk',
			        	src: '//connect.facebook.net/it_IT/sdk/xfbml.customerchat.js', 
			        	type: 'text/javascript', 
			        	charset: 'UTF-8',
			        	async: true,
			        	defer: true,
			        	crossorigin: 'anonymous'
			        }
			    ]}
			    onChangeClientState={(newState, addedTags) => {
			    	if(!Object.keys(addedTags).length || !addedTags.scriptTags) return;
			    	addedTags.scriptTags.forEach((tag) => {
			    		if(tag.id === 'facebook-jssdk') {
			    			tag.onload = initializeFacebook;
			    		}
			    	})
			    }}
			/>
			<Grid 
				container
				justifyContent="space-around"
				spacing={3}
				sx={{
					textAlign: {
						xs: 'center',
						lg: 'left'
					},
					alignItems: 'center',
					flexDirection: {
						xs: 'column-reverse',
						lg: 'row'
					},
					pb: 6
				}}
			>
				<Grid item>
					<Box
						sx={{
							textAlign: 'center',
							mb: 3
						}}
					>
						<Img src={cicLogo} sx={{width: 50, height: 50}} />
					</Box>
					<Typography
						variant="caption"
					>
						CHEF IN CAMICIA S.R.L.<br/> Via Riva di Trento 11A,<br/> 20139 Milano (MI) - Italy<br/> P.IVA: 09096620969
					</Typography>
				</Grid>
				<Grid item>
					<Stack
						direction={isMobile ? "column" : "row"}
					>
						<List dense sx={{py:0}}>
							<ListItem>
								<ListItemButton
									sx={{
										textAlign: {
											xs: 'center',
											lg: 'left'
										},
									}}
									component={NavLink}
									to="/ricette"
								>
									<ListItemText>
										<b>Ricette</b>
									</ListItemText>
								</ListItemButton>
							</ListItem>
							<ListItem>
								<ListItemButton
									sx={{
										textAlign: {
											xs: 'center',
											lg: 'left'
										},
									}}
									component={NavLink}
									to="/chi-siamo"
								>
									<ListItemText>
										<b>Chi siamo</b>
									</ListItemText>
								</ListItemButton>
							</ListItem>
							<ListItem>
								<ListItemButton
									sx={{
										textAlign: {
											xs: 'center',
											lg: 'left'
										},
									}}
									component={NavLink}
									to="/lavora-con-noi"
								>
									<ListItemText>
										<b>Lavora con noi</b>
									</ListItemText>
								</ListItemButton>
							</ListItem>
							{
								(!Boolean(user) || !user.flag_newsletter) &&
								<ListItem>
									<ListItemButton
										sx={{
											textAlign: {
												xs: 'center',
												lg: 'left'
											},
										}}
										component={NavLink}
										to="/newsletter"
									>
										<ListItemText>
											<b>Newsletter</b>
										</ListItemText>
									</ListItemButton>
								</ListItem>
							}
						</List>
						<List dense sx={{py:0}}>
							<ListItem>
								<ListItemButton
									sx={{
										textAlign: {
											xs: 'center',
											lg: 'left'
										},
									}}
									component={Link}
									href="mailto:hello@chefincamicia.com"
								>
									<ListItemText>
										<b>Contattaci</b>
									</ListItemText>
								</ListItemButton>
							</ListItem>
							<ListItem>
								<ListItemButton
									sx={{
										textAlign: {
											xs: 'center',
											lg: 'left'
										},
									}}
									component={Link}
									target="_blank"
									href={Boolean(config) ? config.url_privacy_policy : ''}
								>
									<ListItemText>
										<b>Privacy Policy</b>
									</ListItemText>
								</ListItemButton>
							</ListItem>
							<ListItem>
								<ListItemButton
									sx={{
										textAlign: {
											xs: 'center',
											lg: 'left'
										},
									}}
									component={Link}
									target="_blank"
									href={Boolean(config) ? config.url_terms_and_conditions : ''}
								>
									<ListItemText>
										<b>Termini e Condizioni</b>
									</ListItemText>
								</ListItemButton>
							</ListItem>
							<ListItem>
								<ListItemButton
									sx={{
										textAlign: {
											xs: 'center',
											lg: 'left'
										},
									}}
									className="iubenda-advertising-preferences-link"
								>
									<ListItemText>
										<b>Personalizza tracciamento</b>
									</ListItemText>
								</ListItemButton>
							</ListItem>
						</List>
					</Stack>
				</Grid>
				<Grid item>
					<Stack
						alignItems="center"
					>
						<Box>
							<Typography
								color="text.primary"
							>
								<b>SEGUICI SUI SOCIAL</b>
							</Typography>
							<Box
								sx={{
									'& .social-svg': {
										borderRadius: {
											xs: '5px !important',
											md: '15px !important'
										}
									},
									'& .social-icon': {
										m: {
											xs: 1,
											lg: 2
										},
										width: {
											xs:  '30px !important',
											md: '56px !important'
										},
										height: {
											xs:  '30px !important',
											md: '56px !important'
										}
									}
								}}
							>
								<SocialIcon network="youtube" url="https://www.youtube.com/c/ChefinCamicia" />
								<SocialIcon network="linkedin" url="https://www.linkedin.com/company/chef-in-camicia/" />
								<SocialIcon network="instagram" url="https://www.instagram.com/chefincamicia/" />
								<SocialIcon network="tiktok" url="https://www.tiktok.com/@chefincamicia" />
								<SocialIcon network="facebook" url="https://www.facebook.com/Chefincamicia" />
								<SocialIcon network="whatsapp" url="https://wa.me/393884980459" />
								<SocialIcon network="pinterest" url="https://www.pinterest.it/chefincamicia/" />
							</Box>
						</Box>
					</Stack>
				</Grid>
			</Grid>
		</Box>
	);
}

export default Footer;